export enum CampaignType {
    Creative = 'creative',
    DynamicYield = 'dynamicYield',
}
